/* tslint:disable */
/* eslint-disable */
/**
 * Revisdom API
 * Revisdom uygulaması için REST API dokümantasyonu
 *
 * The version of the OpenAPI document: v1
 * Contact: support@revisdom.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RevisdomAPIViewModelsBasicModelResponse } from './RevisdomAPIViewModelsBasicModelResponse';
import {
    RevisdomAPIViewModelsBasicModelResponseFromJSON,
    RevisdomAPIViewModelsBasicModelResponseFromJSONTyped,
    RevisdomAPIViewModelsBasicModelResponseToJSON,
    RevisdomAPIViewModelsBasicModelResponseToJSONTyped,
} from './RevisdomAPIViewModelsBasicModelResponse';

/**
 * API yanıtları için genel response modeli
 * @export
 * @interface ApiResponse1BasicModelResponse
 */
export interface ApiResponse1BasicModelResponse {
    /**
     * İşlemin başarılı olup olmadığını belirtir
     * @type {boolean}
     * @memberof ApiResponse1BasicModelResponse
     */
    success?: boolean;
    /**
     * İşlem sonucu hakkında bilgi mesajı
     * @type {string}
     * @memberof ApiResponse1BasicModelResponse
     */
    message?: string | null;
    /**
     * 
     * @type {RevisdomAPIViewModelsBasicModelResponse}
     * @memberof ApiResponse1BasicModelResponse
     */
    data?: RevisdomAPIViewModelsBasicModelResponse;
    /**
     * Hata durumunda hata detayları
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ApiResponse1BasicModelResponse
     */
    errors?: { [key: string]: Array<string>; } | null;
}

/**
 * Check if a given object implements the ApiResponse1BasicModelResponse interface.
 */
export function instanceOfApiResponse1BasicModelResponse(value: object): value is ApiResponse1BasicModelResponse {
    return true;
}

export function ApiResponse1BasicModelResponseFromJSON(json: any): ApiResponse1BasicModelResponse {
    return ApiResponse1BasicModelResponseFromJSONTyped(json, false);
}

export function ApiResponse1BasicModelResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResponse1BasicModelResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : RevisdomAPIViewModelsBasicModelResponseFromJSON(json['data']),
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function ApiResponse1BasicModelResponseToJSON(json: any): ApiResponse1BasicModelResponse {
    return ApiResponse1BasicModelResponseToJSONTyped(json, false);
}

export function ApiResponse1BasicModelResponseToJSONTyped(value?: ApiResponse1BasicModelResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'message': value['message'],
        'data': RevisdomAPIViewModelsBasicModelResponseToJSON(value['data']),
        'errors': value['errors'],
    };
}

